import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const UserProfileMenuButtonIntegration = () =>
  import(/* webpackChunkName: "4-feat-user-profile-menu-button" */ './UserProfileMenuButtonIntegration');

const LoadableUserProfileMenuButtonIntegration: React.ComponentType<{ readonly children?: React.ReactNode }> =
  lazyLoadOnRender({ loader: UserProfileMenuButtonIntegration });

export default LoadableUserProfileMenuButtonIntegration;
